import { useQuery } from '@tanstack/react-query';
import { billingService } from '../services/billing';

export const BILLING_COMPANY_QUERY_KEY = ['billing', 'company'] as const;
export const BILLING_CATALOG_QUERY_KEY = ['billing', 'catalog'] as const;
export const BILLING_SUBSCRIPTION_QUERY_KEY = ['billing', 'subscription'] as const;
export const BILLING_SUBSCRIPTION_OFFER_QUERY_KEY = ['billing', 'subscription', 'offer'] as const;

export function billingSubscriptionQueryKey(accountId?: string) {
  return accountId ? [...BILLING_SUBSCRIPTION_QUERY_KEY, accountId] : BILLING_SUBSCRIPTION_QUERY_KEY;
}

export function useBillingCompany(enabled = true) {
  return useQuery({
    queryKey: BILLING_COMPANY_QUERY_KEY,
    queryFn: () => billingService.company(),
    enabled,
    staleTime: 30_000,
  });
}

export function useBillingCatalog(enabled = true) {
  return useQuery({
    queryKey: BILLING_CATALOG_QUERY_KEY,
    queryFn: () => billingService.catalog(),
    enabled,
    staleTime: 30_000,
    refetchOnMount: 'always',
    refetchOnWindowFocus: 'always',
  });
}

export function useBillingSubscription(enabled = true, accountId?: string, retry?: boolean | number) {
  return useQuery({
    queryKey: billingSubscriptionQueryKey(accountId),
    queryFn: () => billingService.subscription(),
    enabled,
    staleTime: accountId ? 0 : 30_000,
    refetchOnMount: accountId ? 'always' : true,
    refetchOnWindowFocus: 'always',
    retry,
  });
}

export function useBillingSubscriptionOffer(userId?: string, enabled = true) {
  return useQuery({
    queryKey: [...BILLING_SUBSCRIPTION_OFFER_QUERY_KEY, userId],
    queryFn: () => billingService.subscriptionOffer(),
    enabled: enabled && Boolean(userId),
    staleTime: 0,
    refetchOnMount: 'always',
  });
}
